// @ts-strict-ignore
import { getCurrentLanguage } from 'shared/services/TranslatorNext/TranslationService';
declare var angular: typeof ng;

interface LoginResponse {
	twoFactorAuthentication?: 'required' | 'not_required';
	'2FAAuthToken'?: string;
	twoFactorAuthenticationMethod?: string;
	isMfaBackupCodesEnabled?: boolean;
}

const showLogin = (function () {
	'use strict';
	// check if account owner is changed
	if (window.location.href.includes('changeOwnerSuccessful')) {
		const urlParams = new URLSearchParams(window.location.href);
		let changeOwnerStatus;
		for (let p of urlParams) {
			// [ 'key' , 'value']
			changeOwnerStatus = p[1];
		}
		window.localStorage.setItem('accountOwnerUpdateStatus', changeOwnerStatus);
	}

	// Initialize theme to auto if not set
	if (!localStorage.getItem('vwo-theme')) {
		localStorage.setItem('vwo-theme', 'auto');
	}

	// Apply theme based on current setting
	const currentTheme = localStorage.getItem('vwo-theme');
	const isDark = currentTheme === 'dark' || (currentTheme === 'auto' && window.matchMedia('(prefers-color-scheme: dark)').matches);

	// Sync data-theme attribute
	if (isDark) {
		document.documentElement.setAttribute('data-theme', 'dark');
	} else {
		document.documentElement.removeAttribute('data-theme');
	}

	if (isDark && document.getElementById('vow-login-logo')) {
		(document.getElementById('vow-login-logo') as HTMLImageElement).src = document.location.protocol + '//' + document.location.host + '/assets/images/wingify-dark.svg';
	}
	if (isDark && document.getElementById('vwo-loader-logo')) {
		(document.getElementById('vwo-loader-logo') as HTMLImageElement).src = document.location.protocol + '//' + document.location.host + '/assets/images/wingify-loader-logo-dark.svg';
	}
	if (isDark && document.getElementById('vwo-logo-setup')) {
		(document.getElementById('vwo-logo-setup') as HTMLImageElement).src = document.location.protocol + '//' + document.location.host + '/assets/images/wingify-logo-dark.svg';
	}

	if (isDark && document.getElementById('vwo-abtasty-shakehand')) {
		(document.getElementById('vwo-abtasty-shakehand') as HTMLImageElement).src = document.location.protocol + '//' + document.location.host + '/assets/images/login/shakehand-dark.png';
	}

	if (isDark && document.getElementById('vwo-abtasty-logo')) {
		(document.getElementById('vwo-abtasty-logo') as HTMLImageElement).src = document.location.protocol + '//' + document.location.host + '/assets/images/login/logo-vwo-abtasty-dark.png';
	}

	// Set theme class for product info section
	const productInfo = document.querySelector('.product-info');
	if (productInfo && isDark) {
		productInfo.classList.add('product-info--dark');
		productInfo.classList.remove('product-info--light');
	} else if (productInfo) {
		productInfo.classList.add('product-info--light');
		productInfo.classList.remove('product-info--dark');
	}

	const loginMsgContainerInfo = document.querySelector('.login-msg-container');
	if (loginMsgContainerInfo && isDark) {
		loginMsgContainerInfo.classList.add('login-msg-container-dark');
	} else if (loginMsgContainerInfo) {
		loginMsgContainerInfo.classList.remove('login-msg-container-dark');
	}

	// Set language attribute based on cookie (duplicate of getFromCookies in CookieUtils.ts)
	function getCookie(name: string): string | null {
		const nameEQ = name + '=';
		const ca = document.cookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1, c.length);
			}
			if (c.indexOf(nameEQ) === 0) {
				return c.substring(nameEQ.length, c.length);
			}
		}
		return null;
	}

	const langCookie = getCookie('lang');
	const locale = langCookie || 'en';
	document.documentElement.setAttribute('lang', locale);

	var $: any = document.querySelector.bind(document);
	var messages = {
		MSG_LOGIN_ERROR: window.i18nextInstance.t('login:msgLoginError'),
		PASSWORD_EXPIRED: `<span>${window.i18nextInstance.t('login:passwordExpired')}<a href="javascript:void(0)" onclick="login.gotoForgotPasswordView()">${window.i18nextInstance.t('login:here')}</a>${window.i18nextInstance.t('login:toResetIt')}</span>`,
		MSG_PASSWORD_RESET_MAIL_SENT: window.i18nextInstance.t('login:msgPasswordResetMailSent'),
		MSG_PASSWORD_RESET_MAIL_FOLLOWUP: window.i18nextInstance.t('login:msgPasswordResetMailFollowup'),
		SET_PASSWORD_MAIL_FOLLOWUP: window.i18nextInstance.t('login:setPasswordMailFollowup'),
		MSG_PASSWORD_RESET_MAIL_EXPIRED: window.i18nextInstance.t('login:msgPasswordResetMailExpired'),
		MSG_USER_REVOKED: window.i18nextInstance.t('login:msgUserRevoked'),
		MSG_PASSWORD_INVITE_MAIL_EXPIRED: `<span>${window.i18nextInstance.t('login:msgPasswordInviteMailExpired')}<a href="javascript:void(0)" onclick="login.gotoForgotPasswordView()">${window.i18nextInstance.t('login:forgotPasswordOption')}</a>${window.i18nextInstance.t('login:optionToSetYourPassword')}</span>`,
		FROM_INVALID: window.i18nextInstance.t('login:formInvalid'),
		MSG_PASSWORDS_DONT_MATCH: window.i18nextInstance.t('login:msgPasswordsDontMatch'),
		MSG_PASSWORD_RESET_SUCCESS: window.i18nextInstance.t('login:msgPasswordResetSuccess'),
		MSG_PASSWORD_SET_SUCCESS: window.i18nextInstance.t('login:msgPasswordSetSuccess'),
		MSG_EMAIL_WRONG: window.i18nextInstance.t('login:msgEmailWrong'),
		RESET: window.i18nextInstance.t('login:reset'),
		REVERIFY: window.i18nextInstance.t('login:reverify'),
		ALREADY_VERIFIED: window.i18nextInstance.t('login:alreadyVerified'),
		DISABLED: window.i18nextInstance.t('login:disabled'),
		INVALID_SSO_USER: window.i18nextInstance.t('login:invalidSSOUser'),
		LOGIN_USING_SSO: window.i18nextInstance.t('login:loginUsingSSO'),
		SSO_NOT_ENABLED: window.i18nextInstance.t('login:ssoNotEnabled'),
		INCORRECT_INPUT: window.i18nextInstance.t('login:incorrectInput'),
		DISABLED_ACCOUNT: window.i18nextInstance.t('login:disabledAccount'),
		ACCOUNT_DELETED: window.i18nextInstance.t('login:accountDeleted'),
		INACTIVE_USER: window.i18nextInstance.t('login:inactiveUser'),
		PASSKEY_INVALID: window.i18nextInstance.t('login:passkeyInvalid'),
		PASSKEY_VALIDATION_FAILED: window.i18nextInstance.t('login:passkeyValidationFailed'),
		UNEXPECTED_ERROR: `<span>${window.i18nextInstance.t('login:unexpectedError')}<a href="mailto:${window.VWO_DOMAIN.supportEmail}">${window.VWO_DOMAIN.supportEmail}</a></span>`
	};
	var initMessageCookieName = 'vwo_login_msg';
	var loginWrap = $('#js-login-wrap');
	var notificationBox = $('#js-notification-box');
	var notificationBoxMsg = $('#js-notification-box-msg');
	var loginButton = $('#js-login-btn');
	var captchaWrap = $('#js-captcha-wrap');
	var ssoLoginButton = $('#js-sso-login-btn');
	var signInHeading = $('#js-sign-in-heading');
	var loadingBarStyleTag;

	var captchaResponse = '';
	var loginStateUrlRegex = /\/(login|forgot-password|set-password|reset|sso)/;
	var hash = '';
	var sender = '';
	var loginEmail = '';
	var authToken = '';
	let loginViaSocialLogin = false;
	let isPasskeyLogin = false;

	enum LoginStates{
		NORMAL = 'normal',
		SSO = 'SSO'
	}

	enum NotificationType {
		INFO = 'info'
	}

	const loginDetailsKey = 'previousLoginDetails';
	const oAuthReturnUrlStorageKey = 'oAuthReturnUrl';
	var previousLoginDetails = localStorage.getItem(loginDetailsKey) ? JSON.parse(localStorage.getItem(loginDetailsKey)!) : null;
	var currentLoginState = previousLoginDetails ? previousLoginDetails.state : LoginStates.NORMAL;

	var fallbackResponse = {
		template: 'style1',
		renderConfig: {
			heading: {
				type: 'text',
				text: window.i18nextInstance.t('login:vwoBlog'),
				color: '#FF2C96'
			},
			background: {
				type: 'img',
				imgUrl: '/assets/images/login/default-background.png',
				alt: window.i18nextInstance.t('login:plainGraphicAlt'),
				color: ''
			},
			subheading: {
				type: 'text',
				text: window.i18nextInstance.t('login:learnBestPractices'),
				color: ''
			},
			cta: {
				type: 'button',
				text: window.i18nextInstance.t('login:readMore'),
				textColor: '#fff',
				color: '#BF3B78',
				hoverColor: '#A33166',
				link: `https://${window.VWO_DOMAIN.website}/blog/?utm_medium=website&utm_source=login-page&utm_campaign=tof_logintool`
			}
		}
	};

	const FormBlockSelectors = {
		loginViewSelector: 'login-form',
		ssoViewSelector: 'sso-form',
		resetPasswordViewSelector: 'password-reset-form',
		forgotPasswordViewSelector: 'forgot-password-form',
		accountOwnerUpdateViewSelector: 'account-owner-update'
	};

	function showFormBlock(formBlockSelector) {
		// hide other form blocks
		for (let key of Object.keys(FormBlockSelectors)) {
			if (FormBlockSelectors[key] !== formBlockSelector) {
				$(`#js-${FormBlockSelectors[key]}`)?.classList.add('form-block--hidden');
			}
		  }

		  $(`#js-${formBlockSelector}`)?.classList.remove('form-block--hidden');
	}

	/**
	 * Hides main app content and prepares for login view
	 */
	function hideMainAppContent() {
		document.getElementById('js-main-container-wrap')!.classList.remove('login-successful');
	}

	/**
	 * Shows main app content after successful login
	 */
	function showMainAppContent() {
		document.getElementById('js-main-container-wrap')!.classList.add('login-successful');
	}

	/**
	 * Shows the login form wrapper
	 */
	function showLoginFormWrapper() {
		loginWrap.classList.remove('D(n)');
	}

	/**
	 * Hides the login form wrapper
	 */
	function hideLoginFormWrapper() {
		loginWrap.classList.add('D(n)');
	}

	function xhr(options) {
		var request = new XMLHttpRequest();
		if (options.method === 'GET' && options.data) {
			options.url += '?' + options.data;
		}
		request.open(options.method, options.url, true);

		request.onload = function (data: any) {
			var response;
			try {
				response = JSON.parse(data.target.responseText);
			} catch (e) {
				// ...
			}
			if (request.status === 200) {
				options.onSuccess(response);
			} else if (request.status >= 400) {
				options.onFail(response);
			}
		};
		request.send(options.data ? JSON.stringify(options.data) : undefined);
	}

	function togglePasswordVisibilityFor(
		inputId: string,
		showIconId: string,
		hideIconId: string
	) {
		var input = $(inputId) as HTMLInputElement | null;
		var showIcon = $(showIconId);
		var hideIcon = $(hideIconId);
		if (!input || !showIcon || !hideIcon) {
			return;
		}
		if (input.type === 'password') {
			input.type = 'text';
			showIcon.classList.add('D(n)');
			hideIcon.classList.remove('D(n)');
		} else {
			input.type = 'password';
			showIcon.classList.remove('D(n)');
			hideIcon.classList.add('D(n)');
		}
	}

	function togglePasswordVisibility() {
		togglePasswordVisibilityFor('#login-password', '#js-password-show-icon', '#js-password-hide-icon');
	}

	function toggleNewPasswordVisibility() {
		togglePasswordVisibilityFor('#js-login-new-password', '#js-new-password-show-icon', '#js-new-password-hide-icon');
	}

	function toggleConfirmPasswordVisibility() {
		togglePasswordVisibilityFor('#js-login-confirm-password', '#js-confirm-password-show-icon', '#js-confirm-password-hide-icon');
	}

	function gotoForgotPasswordView() {
		let loginUsername = $('#login-username').value;
		setNotification();
		showFormBlock(FormBlockSelectors.forgotPasswordViewSelector);
		location.hash = '/forgot-password';
		let forgotPasswordUsername = $('#forgot-password-username');
		forgotPasswordUsername.value = loginUsername;
		setTimeout(() => $('#forgot-password-username').focus(), 100);
	}

	function goToSSOView() {
		let loginUsername = $('#login-username').value;
		setNotification();
		location.hash = '/sso';
		showFormBlock(FormBlockSelectors.ssoViewSelector);
		signInHeading.innerHTML = window.i18nextInstance.t('login:signInToVWOPlatformSSO');
		let ssoUsername = $('#sso-email');
		ssoUsername.value = loginUsername || loginEmail;
		// If previous login state is also of same type(SSO), retrive email and autofill
		if (ssoUsername?.value.length === 0 && previousLoginDetails?.state === LoginStates.SSO) {
			ssoUsername.value = previousLoginDetails.email;
		}
		currentLoginState = LoginStates.SSO;
		setTimeout(() => ssoUsername.focus(), 100);
	}

	function loginUsingSSO(e) {
		e.preventDefault();
		ssoLoginButton.classList.add('is-in-action');
		var username = $('#sso-email').value;
		if (username === ''){
			setNotification(messages.INCORRECT_INPUT);
			ssoLoginButton.classList.remove('is-in-action');
			$('#sso-email').focus();
			return;
		}
		xhr({
			method: 'POST',
			url: normalizeEndpointForRegion('/login/sso', username),
			data: {
				username: username,
				...(window.nextLocation ? { appRedirectUrl: window.nextLocation } : {})
			},
			onSuccess: function (response) {
				if (response && response.url) {
					document.getElementById('sso-button-text')!.innerHTML = window.i18nextInstance.t('login:redirectingToSSO');

					if (loginViaSocialLogin || isPasskeyLogin) {
						currentLoginState = LoginStates.NORMAL;
					} else {
						currentLoginState = LoginStates.SSO;
					}
					let currentLoginDetails = {
						email: username,
						state: currentLoginState
					};
					localStorage.setItem(loginDetailsKey, JSON.stringify(currentLoginDetails));
					window.location.href = response.url;
				} else {
					ssoLoginButton.classList.remove('is-in-action');
				}
			},
			onFail: function (response) {
				ssoLoginButton.classList.remove('is-in-action');
				if (response.isSsoEnabled === 0){
					window.location.href = '/#/login';
					setTimeout(() => setNotification(messages.SSO_NOT_ENABLED), 100);
					let loginUsername = $('#login-username');
					loginUsername.value = username;
				} else {
					setNotification(response.errors && response.errors[0].message || response.message);
				}
			}
		});
	}

	function fetchSocialLoginUrl(provider: string) {
		xhr({
			method: 'POST',
			url: '/login/socialLogin',
			data: {
				provider: provider,
				appRedirectUrl: window.nextLocation
			},
			onSuccess: function (response) {
				if (response && response.url) {
					window.location.href = response.url;
				}
			},
			onFail: function (response) {
				setNotification(response.message || window.i18nextInstance.t('login:socialLoginFailed'));
			}
		});
	}

	function isAbsoluteHttpUrl(url: string): boolean {
		return /^https?:\/\//i.test(url);
	}

	function applyPostLoginRedirect(redirectTarget: string) {
		if (isAbsoluteHttpUrl(redirectTarget)) {
			window.location.href = redirectTarget;
		} else {
			location.hash = redirectTarget;
		}
	}

	function persistReturnUrlFromHash() {
		const returnUrl = new URLSearchParams(location.hash.split('?')[1] || '').get('returnUrl');
		if (returnUrl) {
			// Password reads sessionStorage; SSO reads nextLocation for appRedirectUrl.
			window.nextLocation = returnUrl;
			window.sessionStorage.setItem(oAuthReturnUrlStorageKey, returnUrl);
		}
	}

	function redirectToExternalReturnUrl() {
		const hashReturnUrl = new URLSearchParams(location.hash.split('?')[1] || '').get('returnUrl');
		const returnUrl = window.sessionStorage.getItem(oAuthReturnUrlStorageKey) || hashReturnUrl;
		if (returnUrl && isAbsoluteHttpUrl(returnUrl) && returnUrl.indexOf('login') === -1) {
			window.sessionStorage.removeItem(oAuthReturnUrlStorageKey);
			applyPostLoginRedirect(returnUrl);
			return true;
		}
		return false;
	}

	function gotoLoginView() {
		let ssoUsername = $('#sso-email').value;
		setNotification();
		hideMainAppContent();
		showFormBlock(FormBlockSelectors.loginViewSelector);
		if (!location.hash.match(loginStateUrlRegex)) {
			window.nextLocation = location.hash.replace('#', '');
		}

		persistReturnUrlFromHash();

		if (!window.nextLocation){
			waitForAngular().then(() => {
				var injector = angular.element(document.body)?.injector();
				if (injector) {
					var auth;
					auth = injector.get('auth');
					window.nextLocation = auth.nextLocation;
				}
			});
		}
		let loginUsername = $('#login-username');
		loginUsername.value = ssoUsername;
		// If previous login state is also of same type(username/password), retrive email/username and autofill
		if (loginUsername?.value.length === 0 && previousLoginDetails?.state === LoginStates.NORMAL) {
			loginUsername.value = previousLoginDetails.email;
		}
		currentLoginState = LoginStates.NORMAL;
		setTimeout(() =>  loginUsername.focus(), 100);
		location.hash = '/login';
		signInHeading.innerHTML = window.i18nextInstance.t('login:signInToVWOPlatform');
	}

	function gotoOwnerAccountChangedView(isAccountOwnerUpdatedSuccessfully : string) {
		showFormBlock(FormBlockSelectors.accountOwnerUpdateViewSelector);

		if (isAccountOwnerUpdatedSuccessfully === 'false') {
			// in case of failure show failed icon and text respectively
			$('#owner-update-heading-sucess')!.hidden = true;
			document.getElementById('owner-update-success-notification-icon')!.style.display = 'none';
			document.getElementById('owner-update-fail-notification-icon')!.style.display = 'inline-block';

			$('#owner-update-heading-failed')!.hidden = false;
			document.getElementById('owner-update-sub-heading')!.innerText = window.i18nextInstance.t('login:approvalLinkInvalid');
		}
	}

	/**
	 * Sends an email to the email ID specified to reset the password.
	 */
	function sendResetPasswordEmail() {
		var username = $('#forgot-password-username').value;
		xhr({
			method: 'POST',
			url: '/forgotPassword/sendcode',
			data: { username: username },
			onSuccess: function () {
				setNotification(messages.MSG_PASSWORD_RESET_MAIL_SENT.replace('%email%', username));
			},
			onFail: function (response) {
				setNotification(response.errors && response.errors[0].message || response.message);
			}
		});
	}

	/**
	 * Sends a request to the server to verify if the password recovery hash is valid or not.
	 */
	function verifyResetPasswordHash() {
		let data: string = 'hash=' + hash;
		if (sender) {
			data += '&sender=' + sender;
		}
		return new Promise((resolve, reject) => {
			xhr({
				method: 'GET',
				url: '/forgotPassword',
				data: data,
				onSuccess: resolve,
				onFail: reject
			});
		});
	}

	/**
	 * Sends a reset password query to the server.`
	 */
	function resetPassword() {
		var email = $('#js-login-confirm-email').value,
			newPassword = $('#js-login-new-password').value,
			confirmPassword = $('#js-login-confirm-password').value,
			form = $('#js-password-reset-form');

		var $scope: any = angular.element(form).scope();
		if (!$scope.resetPasswordForm.$valid) {
			setNotification(messages.FROM_INVALID);
			return;
		}

		if (newPassword !== confirmPassword) {
			setNotification(messages.MSG_PASSWORDS_DONT_MATCH);
			return;
		}
		setNotification();
		xhr({
			method: 'POST',
			url: '/forgotPassword/reset?hash=' + hash,
			data: { username: email, password: newPassword, confirmPassword: confirmPassword },
			onSuccess: function () {
				if (isSetPasswordState()) {
					setNotification(messages.MSG_PASSWORD_SET_SUCCESS);
				} else {
					setNotification(messages.MSG_PASSWORD_RESET_SUCCESS);
				}
				login(event, true);
				hideCaptcha();
			},
			onFail: function (response) {
				var msg = response.errors && response.errors[0].message || response.message;
				// HACK: ideally backend should send err code, but now we need to match exact message
				if (msg === 'Incorrect user input') {
					msg = messages.MSG_EMAIL_WRONG;
				}
				setNotification(msg);
			}
		});
	}

	function loginUsingPasskey() {
		xhr({
			method: 'GET',
			url: '/login/passkey/start',
			onSuccess: async function (data) {
				const $injector = angular.element(document.body).injector();
				const stringUtils = $injector.get('stringUtils') as any;
				const args = stringUtils.base64ToArrayBuffer(data.args);
				const authenticationResult = await navigator.credentials.get(args);
				validatePasskeyCredentials(authenticationResult, data);
			},
			onFail: function (response) {
				if (Object.keys(response).length > 0) {
					onLoginFail(response);
				}
			}
		});
	}

	function validatePasskeyCredentials(authenticationResult, data) {
		const $injector = angular.element(document.body).injector();
		const stringUtils = $injector.get('stringUtils') as any;
		const $rootScope: any = $injector.get('$rootScope');
		$rootScope.isPasskeyLogin = true;
		isPasskeyLogin = true;
		xhr({
			method: 'POST',
			url: '/login/passkey/finish',
			data: {
				id: authenticationResult.id,
				client: stringUtils.arrayBufferToBase64(authenticationResult.response.clientDataJSON),
				auth: stringUtils.arrayBufferToBase64(authenticationResult.response.authenticatorData),
				sig: stringUtils.arrayBufferToBase64(authenticationResult.response.signature),
				user: stringUtils.arrayBufferToBase64(authenticationResult.response.userHandle),
				challengeKey: data.challengeKey
			},
			onSuccess: function (data) {
				authToken = data['2FAAuthToken'];

				if (data?.twoFactorAuthentication === 'required') {
					loginWith2FA(data.twoFactorAuthenticationMethod, data);
				} else {
					onLoginSuccess(data);
				}
			},
			onFail: function (response) {
				if (Object.keys(response).length > 0) {
					onLoginFail(response);
				}
			}
		});
	}

	function showCaptcha(response) {
		if (response.showCaptcha) {
			captchaWrap.classList.remove('D(n)');
			if (!window.grecaptcha) {
				var s = document.createElement('script');
				s.src = 'https://www.google.com/recaptcha/api.js?onload=onloadRecaptchaCallback&render=explicit';
				document.head.appendChild(s);
				window.onloadRecaptchaCallback = function () {
					window.grecaptcha.render('recaptcha-placeholder', {
						'sitekey': response.captchaKey,
						'callback': verifyRecaptchaCallback
					});
				};
			} else {
				window.grecaptcha.reset();
			}
		} else {
			captchaResponse = '';
		}
	}

	function hideCaptcha() {
		captchaWrap.classList.add('D(n)');
	}

	var verifyRecaptchaCallback = function (response) {
		captchaResponse = response;
	};

	function setNotification(message?, notificationType?: NotificationType) {
		if (message) {
			notificationBoxMsg.innerHTML = message;
			notificationBox.classList.remove('D(n)');
			if (notificationType === NotificationType.INFO) {
				$('#js-notification-warning-icon').classList.add('D(n)');
				$('#js-notification-info-icon').classList.remove('D(n)');
				notificationBox.classList.add('notification-box--primary');
			} else {
				$('#js-notification-warning-icon').classList.remove('D(n)');
				$('#js-notification-info-icon').classList.add('D(n)');
				notificationBox.classList.remove('notification-box--primary');
			}
		} else {
			notificationBox.classList.add('D(n)');
		}
	}

	function onLoginFail(response) {
		response = typeof response === 'string' ? JSON.parse(response) : response;
		if (response && !!response.isSsoEnabled) {
			goToSSOView();
			setNotification(messages.LOGIN_USING_SSO);
		} else {
			switch (response.message) {
			case 'Password Expired':
				setNotification(messages.PASSWORD_EXPIRED);
				break;
			case 'Inactive account':
				setNotification(messages.DISABLED_ACCOUNT);
				break;
			case 'Inactive User':
				setNotification(messages.INACTIVE_USER);
				break;
			case 'Deleted account':
				setNotification(messages.ACCOUNT_DELETED);
				break;
			case 'No passkey found':
				setNotification(messages.PASSKEY_INVALID);
				break;
			case 'Passkey validation failed':
				setNotification(messages.PASSKEY_VALIDATION_FAILED);
				break;
			case 'RESET':
				setNotification(messages.RESET);
				break;
			default:
				setNotification(messages.MSG_LOGIN_ERROR);
			}

			if (loginViaSocialLogin) {
				showFormBlock(FormBlockSelectors.loginViewSelector);
			}
		}
		showCaptcha(response);
	}


	async function getRedirectionUrl(loggedInUser, injector) {
		// Calculate next path for the redirection function.
		var redirectTo;
		const exploreService = injector.get('exploreService');
		let productService = injector.get('productService');
		// Check for specific redirects in order of priority
		if (loggedInUser.currentAccount.isPlaygroundEnabled && !loggedInUser.currentAccount.isPlaygroundIntroCompleted && loggedInUser.currentAccount.isTrial) {
			// Show welcome screen only if playground is enabled and intro is not completed
			redirectTo = '/onboarding/welcome';
		} else if (loggedInUser.currentAccount.isOnboardingVersion4Enabled &&
			(!Object.values(loggedInUser.currentAccount?.policy?.ruleset?.productsEnabled).length || (!loggedInUser.isAccountVerified && loggedInUser.currentAccount?.isPlaygroundEnabled))
		) {
			redirectTo = '/dashboard/get-started';
		} else if (loggedInUser?.currentAccount?.onboarding &&
			loggedInUser.currentAccount.onboarding.version === 2 &&
			!loggedInUser.currentAccount.onboarding.completed &&
			!loggedInUser.currentAccount.isExpired &&
			(loggedInUser.policy.ruleset.isAdmin || loggedInUser.policy.ruleset.canPublish)) {
			redirectTo = '/ai-setup/recommendation';
		} else if (
			await shouldRedirectToExplore(loggedInUser.currentAccount)) {
			redirectTo = '/explore/overview';
		} else if (!productService.isLegacyTestingEnabled() && loggedInUser.currentAccount.shouldSeeVWOSetup  && !loggedInUser.currentAccount.isExpired &&
			(loggedInUser.policy.ruleset.isAdmin || loggedInUser.policy.ruleset.canPublish) && !loggedInUser.currentAccount.isOnboardingVersion4Enabled) {
			redirectTo = '/setup';
		} else if (!productService.isLegacyTestingEnabled() && Object.keys(loggedInUser.currentAccount?.policy?.ruleset?.productsEnabled).length === 0 && !loggedInUser.currentAccount.isExpired &&
		(loggedInUser.policy.ruleset.isAdmin || loggedInUser.policy.ruleset.canPublish) && !loggedInUser.currentAccount.isOnboardingVersion4Enabled) {
			redirectTo = '/setup/product-selection';
		} else if (window.nextLocation && window.nextLocation.indexOf('login') === -1) {
			if (isAbsoluteHttpUrl(window.nextLocation)) {
				redirectTo = window.nextLocation;
			} else {
				const url = new URL(window.nextLocation, window.location.origin);
				const searchParams = new URLSearchParams(url.search);
				if (url.pathname.startsWith('/settings/upgrade') && searchParams.has('accountId')){
					redirectTo = window.nextLocation;
				} else if (searchParams.has('accountId')) {
					window.sessionStorage.setItem('nextLocationURL', window.nextLocation);
					if (loggedInUser.currentAccount.id !== Number(searchParams.get('accountId'))) {
						const accountId = searchParams.get('accountId');
						redirectTo = `/dashboard?accountId=${accountId}`;
					} else {
						redirectTo = window.nextLocation;
					}
				} else {
					redirectTo = window.nextLocation;
				}
			}
			delete window.nextLocation;
		} else {
			redirectTo = '/dashboard';
			window.sessionStorage.setItem('isNormalLogin', 'true');
		}

		if (isAbsoluteHttpUrl(redirectTo)) {
			return redirectTo;
		}

		return '#' + redirectTo;


		// angular redirections
		/*if (self.nextLocation && self.nextLocation.indexOf('login') === -1) {
			$location.path(self.nextLocation).replace();
			delete self.nextLocation;
		}*/
	}

	function normalizeEndpointForRegion(endpoint, email = '') {
		return endpoint;
		// const dataRegionCacheKey = `dataRegionCacheKey-${email.trim()}`;
		// let result = endpoint;
		// let cachedRegion = JSON.parse(localStorage.getItem(dataRegionCacheKey) || 'null');
		// if (!cachedRegion) {
		// 	cachedRegion = { region: localStorage.getItem('lastDataRegionCacheKey') };
		// }

		// if (cachedRegion) {
		// 	const region = cachedRegion.region || 'US';
		// 	if (region !== 'US') {
		// 		result = `/${region.toLowerCase()}${endpoint}`;
		// 	}
		// }
		// return result;
	}

	function login(e, isLoginViaResetPassword = false) {
		e.preventDefault();
		loginButton.classList.add('is-in-action');
		//Hide captcha and login messsage on login.
		captchaWrap.classList.add('D(n)');
		setNotification();

		const username = isLoginViaResetPassword ? $('#js-login-confirm-email').value : $('#login-username').value;
		var request = new XMLHttpRequest(),
		loginUrl = window.appBaseURI +
		normalizeEndpointForRegion('/login', username);

		request.withCredentials = true;
		request.open('POST', loginUrl, true);

		request.onload = function (data: any) {
			loginButton.classList.remove('is-in-action');
			// clear the credentials
			loginEmail = username;
			$('#login-password').value = '';

			if (request.status === 200) {
				var response = JSON.parse(data.target.response);
				authToken = response['2FAAuthToken'];

				if (response?.twoFactorAuthentication === 'required') {
					loginWith2FA(response.twoFactorAuthenticationMethod, response);
				} else {
					onLoginSuccess(JSON.parse(data.target.response));
				}
			} else if (request.status === 401) {
				onLoginFail(request.responseText);
				if (isLoginViaResetPassword) {
					showFormBlock(FormBlockSelectors.loginViewSelector);
				}
				loginEmail = '';
				// document.getElementById('login-container').removeAttribute("style");
			}
		};
		request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');

		const password = isLoginViaResetPassword ? $('#js-login-confirm-password').value : $('#login-password').value;
		const rememberMe = $('#checkbox-remember').checked;

		request.send(JSON.stringify({
			username: username,
			password: password,
			remember: rememberMe,
			recaptcha_response_field: captchaResponse // eslint-disable-line camelcase
		}));
	}

	function checkForInvalidSSOUser() {
		if (decodeURI(location.hash.split('#/sso?error=')[1]) === 'Invalid User') {
			setNotification(messages.INVALID_SSO_USER);
		} else if (location.hash.includes('#/sso?error=')) {
			setNotification(messages.UNEXPECTED_ERROR);
		}
	}

	function onLoginSuccess(data) {
		if (data.status === 302 && data.location) {
			const redirectUrl = new URL(data.location);
			window.nextLocation && redirectUrl.searchParams.set('fragment', window.nextLocation);

			if (data.location.includes('app.wingify.com')) {
				localStorage.setItem('isWingifyAppSupported', 'true');
			}

			window.location.href = redirectUrl.toString();
			loginButton.classList.add('is-in-action');
			const $injector = angular.element(document.body).injector();
			// eslint-disable-next-line vwo-custom-rules/no-any-type
			const $rootScope = $injector?.get('$rootScope') as any;
			$rootScope && ($rootScope.loginScreen.showLoader = true);
			return;
		}

		let currentLoginDetails = {
			email: data.email,
			state: currentLoginState,
			userId: data.id
		};
		if (redirectToExternalReturnUrl()) {
			return;
		}
		localStorage.setItem(loginDetailsKey, JSON.stringify(currentLoginDetails));
		var metaTag = document.getElementById('meta-viewport') as HTMLMetaElement;
		metaTag.content = 'width=1280';
		window.amILoggedIn = true;
		hideLoginFormWrapper();
		window.localStorage.setItem('isCachedLoad', '1');
		var loginStyleTag = document.querySelector('#login-style');
		if (loginStyleTag) {
			document.head.removeChild(loginStyleTag);
		}
		var loggedInUser = data;

		const accountId = new URLSearchParams(window.location.hash.split('?')[1]).get('accountId');
		let accountsListPromise = fetch(`user/accounts${accountId ? '?accountId=' + accountId : ''}`).then(response => response.json());

		waitForDeps(loggedInUser).then(({aMsgHandlerService, redirectTo}) => {
			var injector = angular.element(document.body).injector();
			try {
				const serverLocale = (loggedInUser && loggedInUser.locale) || 'en';
				const cookieUtils: any = injector.get('cookieUtils');
				const cookieLang = cookieUtils.get('lang');
				const docLang = document.documentElement.getAttribute('lang');
				const i18nLang = getCurrentLanguage();
				const currentLang = (cookieLang || i18nLang || docLang || 'en');
				if (currentLang !== serverLocale) {
					// preserve computed target
					applyPostLoginRedirect(redirectTo);
					cookieUtils.set('lang', serverLocale, undefined, undefined, '/', { samesite: 'none', secure: true });
					document.documentElement.setAttribute('lang', serverLocale);
					window.location.reload();
					return;
				}
			} catch (error) {
				// Ignore errors during locale check
			}
			const MultiTabsUtils: any = injector.get('MultiTabsUtils');
			MultiTabsUtils.broadcast('AppLoggedIn'); // can't import enum

			const commonAnalyticsUtils: any = injector.get('commonAnalyticsUtils');
			const SegmentAnalyticsEnum: any = injector.get('SegmentAnalyticsEnum');
			commonAnalyticsUtils.trackSegmentOnNextLoad(SegmentAnalyticsEnum.COMMON.APP_LOGGED_IN);

			accountsListPromise.then((accountsList) => {
				loggedInUser.accounts = accountsList;
				aMsgHandlerService.setLoginDetails(loggedInUser);
				applyPostLoginRedirect(redirectTo);
				// Get back the loading bar
				loadingBarStyleTag?.remove();
			});

		});
		// Remove all sessionStorage keys that start with 'vwo-setup-call-nudge'
		for (let i = window.sessionStorage.length - 1; i >= 0; i--) {
			const key = window.sessionStorage.key(i);
			if (key && (key.startsWith('vwo-setup-call-nudge') || key.startsWith('paymentReminderShown') || key.startsWith('discountOfferModalShown'))) {
		window.sessionStorage.removeItem(key);
		}
	}

	showMainAppContent();
}

	async function waitForDeps(loggedInUser) {

		return new Promise< {redirectTo: any, aMsgHandlerService: any}>((resolve) => {
			const timer = setInterval(async () => {
				if (typeof angular !== 'undefined') {
					var redirectTo;
					var injector = angular.element(document.body).injector();
					var aMsgHandlerService;
					if (injector) {
						aMsgHandlerService = injector.get('auth');
						redirectTo = await getRedirectionUrl(loggedInUser, injector);
					}
					if (aMsgHandlerService && redirectTo) {
						clearInterval(timer);
						resolve({redirectTo, aMsgHandlerService});
					}
				}
			}, 100);
		});
	}

	function handleSso2FA() {
		const hash = location.hash;
		const queryString = hash.split('?')[1];
		const params = new URLSearchParams(queryString);

		authToken = params.get('2FAAuthToken') || '';
		const twoFactorAuthenticationMethod = params.get('twoFactorAuthenticationMethod') || 'email';
		const isMfaBackupCodesEnabled = params.get('isMfaBackupCodesEnabled') === '1';
		const appRedirectUrl = params.get('appRedirectUrl');
		const emailFromParams = params.get('email') || '';

		if (appRedirectUrl) {
			window.nextLocation = appRedirectUrl;
		}

		loginEmail = emailFromParams;

		const loginResponse: LoginResponse = {
			twoFactorAuthentication: 'required',
			'2FAAuthToken': authToken,
			twoFactorAuthenticationMethod: twoFactorAuthenticationMethod,
			isMfaBackupCodesEnabled: isMfaBackupCodesEnabled
		};

		const tryShow2FA = () => {
			try {
				const injector = angular.element(document.body)?.injector();
				if (injector) {
					loginWith2FA(twoFactorAuthenticationMethod, loginResponse);
					hideMainAppContent();
					return;
				}
			} catch (e) {
				// Module not ready yet
			}
		setTimeout(tryShow2FA, 50);
		};
		tryShow2FA();
	}

	function onStateSuccess() {
		const resetPasswordQueryString = location.hash.split('?')[1];
		const resetPasswordParams = resetPasswordQueryString ? new URLSearchParams(resetPasswordQueryString) : null;
		const resetHash = resetPasswordParams?.get('hash');

		if (resetHash) {
			hash = resetHash;
			sender = resetPasswordParams?.get('sender') || '';
			const [hashPath] = location.hash.split('?');
			history.replaceState(null, '', location.pathname + location.search + hashPath);
		}

		// check if account owner is changed
		const isAccountOwnerUpdatedSuccessfully = window.localStorage.getItem('accountOwnerUpdateStatus');

		if (location.hash.match(/forgot-password|set-password/)) {
			showFormBlock(FormBlockSelectors.forgotPasswordViewSelector);
		} else if (location.hash.match(/sso-2fa/)) {
			handleSso2FA();
		} else if (location.hash.match(/sso/)) {
			showFormBlock(FormBlockSelectors.ssoViewSelector);
			checkForInvalidSSOUser();
			signInHeading.innerHTML = window.i18nextInstance.t('login:signInToVWOPlatformSSO');
		} else if (isAccountOwnerUpdatedSuccessfully) {
			window.localStorage.removeItem('accountOwnerUpdateStatus');
			gotoOwnerAccountChangedView(isAccountOwnerUpdatedSuccessfully);
		} else if (!location.hash.match(/marketing_test_banner=\d/)) {
			gotoLoginView();
		}

		if (resetHash) {
			$('#js-forgot-password-loader')?.classList.remove('D(n)');
			Promise.all([
				verifyResetPasswordHash(),
				waitForAngular()
			]).then(() => {
				showFormBlock(FormBlockSelectors.resetPasswordViewSelector);
				if (isSetPasswordState()) {
					$('#js-password-reset-form-only-button').classList.remove('D(n)');
					setNotification(messages.SET_PASSWORD_MAIL_FOLLOWUP);

					var email = atob(decodeURIComponent(resetPasswordParams!.get('email')!));
					$('#js-login-confirm-email').value = email;
					$('#js-login-confirm-email').setAttribute('disabled', true);
				} else {
					$('#js-password-reset-form-button-with-back').classList.remove('D(n)');
					setNotification(messages.MSG_PASSWORD_RESET_MAIL_FOLLOWUP);

					if (resetPasswordParams?.get('email')) {
						var email = atob(decodeURIComponent(resetPasswordParams.get('email')!));
						$('#js-login-confirm-email').value = email;
						$('#js-login-confirm-email').setAttribute('disabled', true);
					}
				}
			}).catch(response => {
				var msg;
				if (isSetPasswordState()) {
					if (response.errors && response.errors[0].message === 'linkRevoked') {
						msg = messages.MSG_USER_REVOKED;
					} else {
						msg = messages.MSG_PASSWORD_INVITE_MAIL_EXPIRED;
					}
				} else {
					msg = messages.MSG_PASSWORD_RESET_MAIL_EXPIRED;
				}

				setTimeout(() => {
					setNotification(msg);
				}, 100);
				// Unhide the forgot password form hidden because of hash in url
				showFormBlock(FormBlockSelectors.forgotPasswordViewSelector);
				hash = '';
				gotoLoginView();
			})
				.finally(() => {
				$('#js-forgot-password-loader')?.remove();
				});
		}
	}

	function isSetPasswordState() {
		return location.hash.match(/set-password/);
	}

	function showInitLoginMessage() {
		// Show message as directed by a temporary cookie sent by backend.
		// The set of expected values is : { 'MSG_EMAIL_WRONG', 'RESET', 'REVERIFY', 'ALREADY_VERIFIED', 'DISABLED'}
		// @ts-expect-error
		var cookieValue = document.getCookie(initMessageCookieName);
		if (cookieValue) {
			setNotification(messages[cookieValue]);
		}
	}

	function getLoginBannerConfig() {
		const currURL = window.location.href;
		const apiURL = '/marketing/login-page-content';
		const isTestingMode = currURL.indexOf('marketing_test_banner') !== -1;
		const queryParams = isTestingMode ? '?post_config=local' : '';

		return fetch(apiURL + queryParams)
			.then(response => response.json())
			.then((data: any) => {
				if (isTestingMode) {
					let templateID = parseInt(currURL.split('=')[1]);
					return data.find(obj => obj.id === templateID);
				}
				if (data.length === 0) {
					return fallbackResponse;
				}
				let templateIndx = parseInt(String(Math.random() * data.length));
				return data[templateIndx];
			})
			.catch(e => {
				return fallbackResponse;
			});
	}

	function renderLoginBanner() {
		let templates = 3;
		for (let i = 1; i <= templates; i++) {
			let elem = document.getElementById(`style${i}-template`)!;
			elem.style.opacity = '0';
			elem.style.visibility = 'hidden';
		}

		let loadingElem = document.getElementById('loading-template')!;
		loadingElem.style.visibility = 'visible';
		loadingElem.style.opacity = '1';

		getLoginBannerConfig().then(config => {
			const templateContainer = document.getElementById(`${config.template}-template`)!;
			Object.assign(loadingElem.style, {
				visibility: 'hidden',
				opacity: 0,
				transitionTimingFunction: 'ease-in',
				transitionDuration: '200ms'
			});

			for (let [
				key,
				objDummy
			] of Object.entries(config.renderConfig)) {
				let obj: any = objDummy;
				let elem = document.getElementById(`${config.template}-${key}`)!;

				switch (obj.type) {
				case 'img':
					templateContainer.style.backgroundImage = `url(${obj.imgUrl})`;
					break;
				case 'text': {
					elem.innerHTML = obj.text;
					elem.style.color = obj.color;
				}
					break;
				case 'list': {
					obj.text.forEach((value, index) => {
						let listItem = document.createElement('p');
						Object.assign(listItem, {
							innerHTML: value,
							id: 'bulletin-list-item' + index
						});
						listItem.style.cssText = `color: ${obj.color}; border-left: 2px solid ${obj.listStyleColor}; padding-left: 20px; margin-bottom: ${index < (obj.text.length - 1) ? 40 : 0}px;`;
						if (!document.getElementById(listItem.id)) {
							elem.appendChild(listItem);
						}
					});
				}
					break;
				case 'button': {
					Object.assign(elem, {
						href: obj.link,
						innerHTML: obj.text,
						onmouseenter: () => elem.style.backgroundColor = obj.hoverColor,
						onmouseleave: () => elem.style.backgroundColor = obj.color
					});
					elem.style.cssText = `color: ${obj.textColor}; background-color: ${obj.color}`;
				}
				}
			}

			templateContainer.style.backgroundColor = config.renderConfig?.background.color;
			templateContainer.style.transitionTimingFunction = 'ease-in';
			templateContainer.style.transitionDuration = '200ms';
			templateContainer.style.opacity = '1';
			templateContainer.style.visibility = 'visible';
		});
	}

	async function handleSocialLoginResponse(socialLoginKey: string) {
		return new Promise((resolve, reject) => {
			xhr({
				method: 'GET',
				url: `/login/socialLoginResponse?socialLoginKey=${socialLoginKey}`,
				onSuccess: function (response) {
					if (response.twoFactorAuthentication === 'required') {
						authToken = response['2FAAuthToken'];
						loginWith2FA(response.twoFactorAuthenticationMethod, response);
					} else {
						onLoginSuccess(response);
					}
				},
				onFail: function (response) {
					if (Object.keys(response).length > 0) {
						onLoginFail(response);
					}
				}
			});
			resolve(undefined);
		});
	}

	/**
	 * Shows login box and processes URL if required. Called after initial login verification
	 * from index.html.
	 * @param  {Boolean | Object} param If boolean informs whether user is logged in.
	 *				If object, it serves as response from the login request.
	 */
	async function init(param) {
		var isLoggedIn;
		var response;
		var metaTag = document.getElementById('meta-viewport') as HTMLMetaElement;
		loginViaSocialLogin = false;
		isPasskeyLogin = false;

		const hash = location.hash; // e.g., "#/forgot-password?hash=...&email=..."
		const queryString = hash.split('?')[1]; // get the part after '?'
		const params = new URLSearchParams(queryString);

		if (params.get('socialLoginKey')) {
			await waitForAngular();
			loginViaSocialLogin = true;
		}
		if (typeof (param) === 'boolean') {
			isLoggedIn = param;
		} else {
			isLoggedIn = (param && (param.status === 200));
			response = (param && param.responseText !== '' && JSON.parse(param.responseText));
		}
		// If not logged in
		if (!isLoggedIn) {
			document.title = window.i18nextInstance.t('login:pageTitle');
			metaTag.content = 'width=device-width, initial-scale=1';
			persistReturnUrlFromHash();
		if (response) {
			showCaptcha(response);
		}
		if (!location.hash.match(/sso-2fa/)) {
			hideMainAppContent();
		}
		showLoginFormWrapper();
		// Hide the top loading bar while we are logged out
			if (!document.getElementById('loading-bar-style-tag')) {
				loadingBarStyleTag = document.createElement('style');
				loadingBarStyleTag.id = 'loading-bar-style-tag';
				loadingBarStyleTag.textContent = '#loading-bar { display: none!important; }';
				document.head.appendChild(loadingBarStyleTag);
			}
			if (loginViaSocialLogin) {
				$('#js-login-form')?.classList.add('form-block--hidden');
				const socialLoginKey = params.get('socialLoginKey')!;
				// Strip all hash query params (including the one-time socialLoginKey) so a refresh can't replay them.
				// Use replaceState (not `location.hash = …`) to avoid firing hashchange and re-entering AngularJS routing.
				const [hashPath] = hash.split('?');
				history.replaceState(null, '', location.pathname + location.search + hashPath);

				await handleSocialLoginResponse(socialLoginKey);
				return;
			}
			// Check if last login is of type SSO. Otherwise by default will display username/password login page
			if (currentLoginState === LoginStates.SSO && (!location.hash || location.hash.includes('#/login'))) {
				goToSSOView();
			}

			onStateSuccess();
			showInitLoginMessage();
			await waitForAngular();
			const $injector = angular.element(document.body).injector();
			if ($injector) {
				const $rootScope: any = $injector.get('$rootScope');
				// Initialize loginScreen with default values to prevent template evaluation issues
				if (!$rootScope.loginScreen) {
					$rootScope.loginScreen = {
						isOTPScreenVisible: false,
						isTotpAuthRequired: false,
						isUsingBackupCode: false,
						isMfaBackupCodesEnabled: false
					};
				}
				// eslint-disable-next-line vwo-custom-rules/no-any-type
				const exploreService = $injector.get('exploreService') as any;
				exploreService.removeExploreScreenVisited();
			}
			if (window.nextLocation?.includes('/dashboard?enableNewFlowForAll=true')) {
				setNotification(window.i18nextInstance.t('login:enableNewCampaignFlow'), NotificationType.INFO);
			}
			//renderLoginBanner();
		} else if (response) {
			metaTag.content = 'width=1280';
			var url = window.location.href;
			// check token for shareable link
			var hasToken = url.indexOf('?token=') !== -1 || url.indexOf('&token=') !== -1;
			// If user is logged in & the account is not set up, we need to redirect to setup page.
			if (response.currentAccount.isPlaygroundEnabled && !response.currentAccount.isPlaygroundIntroCompleted && response.currentAccount.isTrial) {
				location.hash = '/onboarding/welcome';
			} else if (!hasToken && response.currentAccount.isOnboardingVersion4Enabled &&
				(!Object.values(response.currentAccount?.policy?.ruleset?.productsEnabled).length || (!response.isAccountVerified && response.currentAccount?.isPlaygroundEnabled))) {
				location.hash = '/dashboard/get-started';
			} else if (!hasToken &&
				response.currentAccount?.onboarding &&
				response.currentAccount.onboarding.version === 2 &&
				!response.currentAccount.onboarding.completed) {
				location.hash = '/ai-setup/recommendation';
			} else if (
				await shouldRedirectToExplore(response.currentAccount)
			) {
				location.hash = '/explore/overview';
			} else if (
				response.currentAccount &&
				!hasToken &&
				response.currentAccount.shouldSeeVWOSetup &&
				!response.currentAccount.isExpired &&
				(response.policy.ruleset.isAdmin || response.policy.ruleset.canPublish)
				&& !response.currentAccount.isOnboardingVersion4Enabled
				&& !response.currentAccount.isPlaygroundAccount
			) {
				location.hash = '/setup/account-setup';
			} else if (!hasToken && window.location.hash.split('?')[0] === '#/login') {
				persistReturnUrlFromHash();
				if (!redirectToExternalReturnUrl()) {
					location.hash = '/dashboard';
				}
			}
		}
	}

	// Check if this is not a cached load, fallback to system font so that login doesn't have to wait for the main fonts to load and neither sees a flicker on login
	if (!window.localStorage || !window.localStorage.getItem('isCachedLoad')) {
		var style = document.createElement('style');
		style.id = 'login-style';
		style.textContent = '.login-container { font-family: Helvetica, sans-serif; }';
		document.head.appendChild(style);
	}

	// eslint-disable-next-line vwo-custom-rules/no-unremoved-window-listeners
	window.addEventListener('hashchange', function () {
		if (!window.amILoggedIn && location.hash.indexOf('login') !== -1) {
			init(false);
		}
	});

	function waitForAngular() {
		return new Promise((resolve) => {
			if (window.angular) {
				try {
					window.angular.module('vwo');
					resolve(undefined);
					return;
				} catch (e) {
					// ignore module not found error and wait more
				}
			}

			setTimeout(() => {
				waitForAngular().then(resolve);
			}, 200);
		});
	}

	function loginWith2FA(authMode, loginResponse?: LoginResponse) {
		const $injector = angular.element(document.body).injector();
		const $rootScope: any = $injector.get('$rootScope');
		// Extract feature flag from login response - backend sends this at root level
		const isMfaBackupCodesEnabled = loginResponse?.isMfaBackupCodesEnabled;

		$rootScope.loginScreen = {
			loginEmail: loginEmail,
			isOTPScreenVisible: true,
			isTotpAuthRequired: authMode === 'totp',
			resendBtnTimer: 20,
			generateOTP: generateOTP,
			loginWithOtp: loginWithOtp,
			loginWithBackupCode: loginWithBackupCode,
			isUsingBackupCode: false,
			isMfaBackupCodesEnabled: isMfaBackupCodesEnabled,
			isMaxLimitReached: false,
			hideOtpScreen: () => {
				$rootScope.loginScreen.isOTPScreenVisible = false;
			},
			switchToBackupCode: () => {
				if ($rootScope.loginScreen.isMfaBackupCodesEnabled) {
					$rootScope.loginScreen.isUsingBackupCode = true;
					$rootScope.loginScreen.otp = '';

					// Check if backup code max limit was reached within the last 15 minutes
					const isBackupCodeMaxLimitReached = checkBackupCodeMaxLimitReached();
					$rootScope.loginScreen.isMaxLimitReached = isBackupCodeMaxLimitReached;

					if (isBackupCodeMaxLimitReached) {
						// Show persisted max limit error in the existing notification box, using same message as backend
						// This will only be visible on the backup code screen because we set this flag when switching modes
						setNotification(window.i18nextInstance.t('login:maximumAttemptsReached'));
					} else {
						setNotification();
					}
				}
			},
			switchTo2FACode: () => {
				$rootScope.loginScreen.isUsingBackupCode = false;
				$rootScope.loginScreen.otp = '';
				$rootScope.loginScreen.isMaxLimitReached = false;
				setNotification(); // Clear any error notifications when switching modes
			},
			retryInterval: undefined,
			isSocialLogin: loginViaSocialLogin
		};

		if (!$rootScope.loginScreen.isTotpAuthRequired) {
			generateOTP();
		}
	}

	function loginWithOtp() {
		const $injector = angular.element(document.body).injector();
		const $http = $injector.get('$http');
		const $rootScope: any = $injector.get('$rootScope');

		$rootScope.loginScreen.showLoader = true;
		setNotification();

		$http({
			url: window.appBaseURI + '/login/authToken',
			method: 'POST',
			data: {
				action: $rootScope.loginScreen.isTotpAuthRequired ? '2FA-totp-verify' : '2FA-login',
				accessToken: $rootScope.loginScreen.otp,
				'2FAAuthToken': authToken
			}
		}).then(function (response) {
			$rootScope.loginScreen.showLoader = false;
			onLoginSuccess(response.data);
		}).catch((response) => {
			$rootScope.loginScreen.showLoader = false;
			if (response.status === 401) {
				$rootScope.loginScreen.hideOtpScreen();
			} else {
				if (response.data.errors?.[0]?.data?.errMsg === 'MAX_LIMIT_REACHED') {
					$rootScope.loginScreen.isMaxLimitReached = true;
					$rootScope.loginScreen.otp = '';

					if ($rootScope.loginScreen.isTotpAuthRequired) {
						$rootScope.loginScreen.resendBtnTimer = response.data.errors[0].data.remTimer ?? 60;
						setRetryCodeTimer($rootScope.loginScreen.resendBtnTimer);
					}
				} else {
					setNotification(response.data.errors[0].message);
				}
			}
		});
	}

	function getBackupCodeMaxLimitKey(email: string): string {
		// Email-based key so multiple accounts (different emails) each track their own 15‑minute window
		return `backupCodeLimitReached:${email.toLowerCase()}`;
	}

	function checkBackupCodeMaxLimitReached(): boolean {
		if (!loginEmail) {
			return false;
		}

		const key = getBackupCodeMaxLimitKey(loginEmail);
		const stored = localStorage.getItem(key);
		if (!stored) {
			return false;
		}

		const timestamp = Number(stored);
		if (!Number.isFinite(timestamp)) {
			localStorage.removeItem(key);
			return false;
		}

		const fifteenMinutesInMs = 15 * 60 * 1000;
		if (Date.now() - timestamp > fifteenMinutesInMs) {
			localStorage.removeItem(key);
			return false;
		}

		return true;
	}

	async function loginWithBackupCode() {
		const $injector = angular.element(document.body).injector();
		const $http = $injector.get('$http');
		const $rootScope = $injector.get('$rootScope') as ng.IRootScopeService & { loginScreen: { showLoader: boolean; otp: string; hideOtpScreen: () => void; isMfaBackupCodesEnabled?: boolean; isMaxLimitReached?: boolean; loginEmail?: string } };

		// Check if backup codes feature is enabled
		if (!$rootScope.loginScreen.isMfaBackupCodesEnabled) {
			return;
		}

		$rootScope.loginScreen.showLoader = true;
		setNotification();

		const payload: { backupCode: string; email: string; '2FAAuthToken': string } = {
			backupCode: $rootScope.loginScreen.otp,
			email: loginEmail,
			'2FAAuthToken': authToken
		};

		$http({
			url: window.appBaseURI + '/login/backup-code',
			method: 'POST',
			data: payload
		}).then(function (response) {
			$rootScope.loginScreen.showLoader = false;
			onLoginSuccess(response.data);
		}).catch((response) => {
			$rootScope.loginScreen.showLoader = false;
			if (response.status === 401) {
				$rootScope.loginScreen.hideOtpScreen();
			} else {
				if (response.data.errors?.[0]?.data?.errMsg === 'MAX_LIMIT_REACHED') {
					$rootScope.loginScreen.isMaxLimitReached = true;
					$rootScope.loginScreen.otp = '';

					// Extract email from error response if available
					const errorEmail = response.data.errors?.[0]?.data?.email;
					if (errorEmail) {
						loginEmail = errorEmail;
						$rootScope.loginScreen.loginEmail = errorEmail;
					}

					// Store per-email timestamp for 15 minutes persistence.
					// Each email (account) gets its own independent key.
					const key = getBackupCodeMaxLimitKey(loginEmail);
					localStorage.setItem(key, String(Date.now()));
					setNotification(response.data.errors[0].message);
				}
				// For non max-limit errors, show the backend message as usual
				if (response.data.errors?.[0]?.data?.errMsg !== 'MAX_LIMIT_REACHED') {
					setNotification(response.data.errors[0].message);
				}
			}
		});
	}

	function generateOTP() {
		const $injector = angular.element(document.body).injector();
		const $http = $injector.get('$http');
		const $rootScope: any = $injector.get('$rootScope');

		$rootScope.loginScreen.isMaxLimitReached = false;
		setNotification();
		$rootScope.loginScreen.disableResend = true;

		$http({
			url: window.appBaseURI + '/account/access-token/send/login',
			method: 'POST',
			data: {
				action: '2FA-login',
				'2FAAuthToken': authToken
			}
		}).then(function (data) {
			$rootScope.loginScreen.disableResend = false;
			setRetryCodeTimer(20);
		}).catch((e) => {
			if (e.status === 401) {
				$rootScope.loginScreen.hideOtpScreen();
			} else {
				$rootScope.loginScreen.disableResend = false;
				setNotification(e.data.errors[0].message);
			}
		});
	}

	async function shouldRedirectToExplore(account) {
		if (account?.onboarding?.version !== 3) {
			return false;
		}
		await waitForAngular();
		const $injector = angular.element(document.body).injector();
		const $rootScope = $injector.get('$rootScope') as any;
		const exploreService = $injector.get('exploreService') as any;
		const campaignUtils = $injector.get('campaignUtils') as any;
		const CampaignResource = $injector.get('CampaignResource') as any;
		$rootScope.campaignsCount || await CampaignResource.queryCampaignsCount().then(campaignsCount => {
			$rootScope.campaignsCount = campaignsCount;
			return campaignsCount;
		});

		if (campaignUtils.getCreatedCampaignCountAcrossProducts() === 0 &&
			!exploreService.isExploreScreenVisited()) {
			return true;
		} else {
			return false;
		}
	}

	function setRetryCodeTimer(timer) {
		let $injector = angular.element(document.body).injector();
		let $interval = $injector.get('$interval');
		let $rootScope: any = $injector.get('$rootScope');

		$interval.cancel($rootScope.loginScreen.retryInterval);

		$rootScope.loginScreen.resendBtnTimer = timer;
		$rootScope.loginScreen.retryInterval = $interval(() => {
			if (!$rootScope?.loginScreen.resendBtnTimer) {
				if ($rootScope.loginScreen.isTotpAuthRequired) {
					$rootScope.loginScreen.isMaxLimitReached = false;
				}
				$interval.cancel($rootScope.loginScreen.retryInterval);
			}
			$rootScope.loginScreen.resendBtnTimer--;
		}, 1000);
	}

	window.login = {
		gotoForgotPasswordView: gotoForgotPasswordView,
		gotoLoginView: () => {
			gotoLoginView();
		},
		login: login,
		init: init,
		sendResetPasswordEmail: sendResetPasswordEmail,
		resetPassword: resetPassword,
		goToSSOView: goToSSOView,
		loginUsingSSO: loginUsingSSO,
		fetchSocialLoginUrl: fetchSocialLoginUrl,
		loginUsingPasskey: loginUsingPasskey,
		togglePasswordVisibility: togglePasswordVisibility,
		toggleNewPasswordVisibility: toggleNewPasswordVisibility,
		toggleConfirmPasswordVisibility: toggleConfirmPasswordVisibility
	};
});

export {showLogin};
